export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./User.vue?vue&type=style&index=0&id=32590e1e&prod&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/components/header/User.vue?vue&type=style&index=0&id=32590e1e&prod&scoped=true&lang=css&
// module id = 889
// module chunks = 0